import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const Services = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  const getResizedImageUrl = (url, width = 600, quality = 80) => {
    if (!url || !url.startsWith('https://assets.auxodev.dk/')) return url;
    if (url.includes('/cdn-cgi/image/')) return url;
    return url.replace('https://assets.auxodev.dk/', `https://assets.auxodev.dk/cdn-cgi/image/width=${width},quality=${quality},format=auto/`);
  };

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await fetch('https://api.dev.auxo.dk/public/content/services');
        const data = await response.json();
        setServices(data);
      } catch (error) {
        console.error('Error fetching services:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  if (loading) return (
    <div className="py-24 text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-orange-600 mx-auto"></div>
      <p className="mt-4 text-slate-600">Indlæser ydelser...</p>
    </div>
  );

  return (
    <section id="ydelser" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            Professionelle løsninger <br />til dit hjem og byggeri
          </p>
          <div className="h-1.5 w-20 bg-orange-600 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div
              key={service.id}
              className="group bg-white overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 border border-slate-100"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={getResizedImageUrl(service.image[0], 600)}
                  alt={service.title.da}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-slate-900 mb-4 transition-colors">
                  {service.title.da}
                </h3>
                <div 
                  className="text-slate-600 mb-6 line-clamp-3"
                  dangerouslySetInnerHTML={{ __html: service.description.da }}
                />
                <Link
                  to={`/ydelser/${service.slug.da}`}
                  className="inline-flex items-center text-black font-bold text-base group/link"
                >
                  Læs mere
                  <ArrowRight className="ml-2 h-5 w-5 group-hover/link:translate-x-1 transition-transform" />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
